import React from 'react';
import { Typography, Descriptions } from 'antd';
import { Status } from '../Status/Status.component';
import { UseNocItemContext } from '../../../../pages/Dashboard/StationScreen';

const { Text, Title } = Typography;

const labelStyle = {
    color: 'var(--dark-theme-text-secondary',
    fontSize: 12,
    padding: 0,
    lineHeight: 0,
}

const contentStyle = {
    color: 'white',
    padding: 0,
    marginBottom: 10,        
}

export const CustomerInformationCard = ({dataSource, ...props}) => {

    const { companyName, email, firstName, lastName, phone, } = UseNocItemContext();

    return(
        <>
            <div {...props} className={`${props.className || ''} card__customer-information`} >        
                <Descriptions 
                    colon={false}
                    layout='vertical' 
                    column={1}
                    styles={{ 
                        content: contentStyle,
                        label: labelStyle
                    }}
                    size='small'
                    >
                    <Descriptions.Item label='Customer Information'>
                        <Title level={5} style={{marginTop: 0, marginBottom: 10}}>
                            {companyName || ''}
                            {/* <Status status={dataSource.alertStatus} blink={!dataSource.alertStatus} tooltipText='Alert Status' style={{marginLeft: 8, }}/> */}
                        </Title>
                    </Descriptions.Item>
                    <Descriptions.Item label='Customer Name'>{firstName} {lastName}</Descriptions.Item>
                    <Descriptions.Item label='Email Address'><Text copyable={email || false}>{email || 'N/A'}</Text></Descriptions.Item>
                    <Descriptions.Item label='Phone Number'>{phone || 'N/A'}</Descriptions.Item>
                    {/* <Descriptions.Item label='Access Type'>
                        <Tag color={dataSource.access ? 'orange' : 'blue'}>
                            {dataSource.access ? 'Read/Write Access' : 'Read Access'}
                        </Tag>
                    </Descriptions.Item> */}
                </Descriptions>
            </div>
        </>
    );
};